import { Repository } from '../../../core/context/repository';
import { type Responsible } from './entity';

export class Responsibles extends Repository<Responsible> {}
